import { render, staticRenderFns } from "./SelfPickUp.vue?vue&type=template&id=554debde&"
import script from "./SelfPickUp.vue?vue&type=script&lang=js&"
export * from "./SelfPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports